window.addEventListener("DOMContentLoaded", (event) => {
    // Display the result in the element with id="demo"
    const elem = document.getElementById("countdown");
    if(elem) {
        const dataDate = elem.dataset.marathonDate;

        // Set the date we're counting down to
        var countDownDate = new Date(dataDate).getTime();

        daysElem =  document.getElementById('days');
        hoursElem =  document.getElementById('hours');
        minutesElem =  document.getElementById('minutes');
        secondsElem =  document.getElementById('seconds');
    
        // Update the count down every 1 second
        var x = setInterval(function () {
    
            // Get today's date and time
            var now = new Date().getTime();
    
            // Find the distance between now and the count down date
            var distance = countDownDate - now;
    
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    
            // elem.innerHTML = days + "d " + hours + "h "
            //     + minutes + "m " + seconds + "s ";

            daysElem.innerHTML = days;
            hoursElem.innerHTML = hours;
            minutesElem.innerHTML = minutes;
            secondsElem.innerHTML = seconds;
    
            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                document.getElementById("demo").innerHTML = "EXPIRED";
            }
        }, 1000);
    }
});
